import React from "react";
import MessageText from "../components/MessageText"

const NoMatch = (props) => {
    return (<MessageText text="SAYFA BULUNAMADI. LÜTFEN LİNKİ KONTROL EDİNİZ." />)
};

export default NoMatch;
